<template>
    <div class="bullet-chat" style="min-height: 300px;">
        <div class="content">
            <el-scrollbar ref="scrollbar" style="height: 100%">
                <div class="title-box">
                    <img class="decorate" src="~assets/image/student/live/scriptRightDecorate.png" />
                    <div class="title">历史弹幕</div>
                </div>
                <div class="list" v-if="liveState != 0 && liveState != 4">
                    <div class="container" ref="chatContainer">
                        <!-- <div class="item" v-for="(item, index) in list" :key="item.id"> -->
                        <div class="item" v-for="(item, index) in list" :key="index">
                            <div class="avatar-box">
                                <img class="avatar-img" :src="item | imgSrc(emptyAvatar)" alt="user" title="user" />
                            </div>
                            <div class="desc">
                                <span class="username">{{ item.nickname }}：</span>
                                <span class="content">{{ item.barrage }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
export default {
    name: "LiveBulletChat",
    data() {
        return {
            emptyAvatar: require("assets/image/blank_headPic.png"),
        };
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        liveState: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        list: {
            handler(newVal, oldVal) {
                this.$nextTick(()=>{
                    this.scrollToBottom();
                })
            // 在这里处理 list 变化时的逻辑
            },
        deep: true, // 深度监听数组内部的变化
        }},
    filters: {
        imgSrc(item, empty) {
            return item.avatar ? item.avatar : empty;
        },
    },
    computed: {},
    components: {},
    methods: {
        scrollToBottom() {
            const scrollbar = this.$refs.scrollbar;
            if (scrollbar) {
                const wrap = scrollbar.wrap;
                if (wrap) {
                wrap.scrollTop = wrap.scrollHeight;
                }
            }
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.bullet-chat {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    color: #fff;
    padding: 20px 0;
    .title-box {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-left: 20px;
        font-size: 18px;
        .decorate {
            width: 31px;
            height: 11px;
            margin-right: 10px;
            vertical-align: middle;
        }
    }
    .content {
        flex: 1;
        overflow: hidden;
        .list {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            .container {
                box-sizing: border-box;
                width: 75%;
                overflow: hidden;
            }
            .item {
                box-sizing: border-box;
                display: flex;
                width: fit-content;
                padding-right: 10px;
                margin-bottom: 15px;
                font-size: 16px;
                color: #fff;
                background-color: rgba(0, 0, 0, 0.3);
                border-radius: 15px;
                .avatar-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 24px;
                    height: 24px;
                    margin-right: 9px;
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: #fff;
                    vertical-align: middle;
                    .avatar-img {
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                }
                .desc {
                    flex: 1;
                    overflow: hidden;
                    line-height: 27px;
                    word-break: break-all;
                    .username {
                        color: #4b45ff;
                    }
                }
            }
        }
    }
}
::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
    margin-right: 0px !important;
    margin-bottom: 0px !important;

    &::-webkit-scrollbar{
        display: none !important;
    }

}


</style>
